









'use strict';

var ApplyAnimatedValues={
current:function ApplyAnimatedValues(instance,props){
if(instance.setNativeProps){
instance.setNativeProps(props);
}else{
return false;
}
},
inject:function inject(apply){
ApplyAnimatedValues.current=apply;
}};


module.exports=ApplyAnimatedValues;


//////////////////
// WEBPACK FOOTER
// ./~/animated/lib/injectable/ApplyAnimatedValues.js
// module id = 265
// module chunks = 0